import { EllipsisText } from "@components/ellipsis-text";
import { Modal } from "@components/modal";
import { RowTable } from "@components/row-table";
import { Config, DoubleText } from "@components/table";
import {
  PaymentCredited,
  PaymentNotCredited,
  PaymentProcessing,
} from "@features/appeals/components/status";
import { Order } from "@features/order/api";
import { formatDate, formatTime } from "@helpers/date";
import { formatRubles, formatUsdt } from "@helpers/format";

type Props = {
  isOpen: boolean;
  hide: () => void;
  order: Order;
};

const config: Config<Order> = [
  {
    source: "id",
    label: "ID",
    renderComponent: (data) => (
      <EllipsisText text={data} startLength={10} copy />
    ),
  },
  {
    label: "Сумма заявки",
    source: "order_start_amount",
    renderComponent: (data, item) => (
      <DoubleText
        subText={formatRubles(data)}
        text={formatUsdt(item.order_start_amount_usdt)}
      />
    ),
  },
  {
    label: "Сумма мерчанта",
    source: "merchant_amount",
    renderComponent: (data, item) => {
      if (item.merchant_amount_usdt == null || data == null) return "";
      const usdt = formatUsdt(item.merchant_amount_usdt);
      const rubles = formatRubles(data);

      return <DoubleText text={usdt} subText={rubles} />;
    },
  },
  {
    label: "Итоговая сумма",
    source: "order_final_amount",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.order_final_amount_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  { source: "exchange_rate", label: "Курс" },
  { source: "requisite", label: "Реквизиты" },
  { source: "device_name", label: "Устройство" },
  {
    source: "ern",
    label: "Сумма прибыли",
    renderComponent: (data, item) => (
      <DoubleText
        text={formatUsdt(item.ern_usdt)}
        subText={formatRubles(data)}
      />
    ),
  },
  {
    source: "created_at",
    label: "Дата и время",
    renderComponent: (data) => (
      <span>
        {formatDate(new Date(data))}, {formatTime(new Date(data))}
      </span>
    ),
  },
];

export const TraderDetailedOrderModal = ({ isOpen, hide, order }: Props) => {
  return (
    <Modal title={`Заявка №${order.id}`} isOpen={isOpen} onClose={hide}>
      {order.status === "completed" && <PaymentCredited />}
      {order.status === "canceled" && <PaymentNotCredited />}
      {(order.status === "processing" || order.status === "pending") && (
        <PaymentProcessing text="Ожидает подтверждения" />
      )}
      {order.status === "dispute_open" && (
        <PaymentProcessing text="Открыт спор" />
      )}
      <RowTable config={config} data={order} />
    </Modal>
  );
};
